import { render, staticRenderFns } from "./Express.vue?vue&type=template&id=211e59b8&scoped=true&"
var script = {}
import style0 from "./Express.vue?vue&type=style&index=0&id=211e59b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e59b8",
  null
  
)

export default component.exports